import React from "react";

function TickBlackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 22.452C6.258 22.452 1.548 17.804 1.548 12 1.548 6.258 6.196 1.548 12 1.548c5.742 0 10.452 4.648 10.452 10.452 0 5.742-4.648 10.452-10.452 10.452zm6.853-13.305L10.12 17.81a.58.58 0 01-.821-.003l-4.155-4.19a.58.58 0 01.003-.82l.412-.41a.58.58 0 01.821.004l3.338 3.364 7.908-7.845a.58.58 0 01.821.004l.41.412a.58.58 0 01-.004.821z"></path>
        </g>
      </g>
    </svg>
  );
}

export default TickBlackIcon;
